<template>
  <div ref="videoAreaRef" class="wrapper" :style="{ height: videoAreaHeight }">
    <video ref="videoRef" autoplay muted playsinline class="video" />
    <div class="live-indicator" :class="isLive ? 'live' : 'stale'"></div>
  </div>
</template>

<script>
import mpegts from 'mpegts.js';

export default {
  name: 'VideoPlayer',
  data() {
    return {
      player: null,
      isLive: true,
      lastUpdate: Date.now(),
      videoWidth: 500,
      checkInterval: null,
      observer: null
    };
  },
  computed: {
    videoAreaHeight() {
      return `${this.videoWidth * (1068 / 600)}px`;
    }
  },
  methods: {
    startLiveCheck() {
      this.checkInterval = setInterval(() => {
        this.isLive = (Date.now() - this.lastUpdate) < 1000;
      }, 500);
    },
    startPlayer() {
      const videoElement = this.$refs.videoRef;

      if (mpegts.getFeatureList().mseLivePlayback && videoElement) {
        this.player = mpegts.createPlayer({
          type: 'mpegts',
          isLive: true,
          url: `${this.$store.state.axiosAddr}/test?selected_machine=${localStorage.selected_machine}&value[path]=/video&value[port]=8080&token=${localStorage.token}`,
          liveSync: true,
          sound: true,
          enableStashBuffer: false
        });

        this.player.attachMediaElement(videoElement);
        this.player.load();
        this.player.play();

        videoElement.addEventListener('timeupdate', () => {
          this.lastUpdate = Date.now();
        });

        this.startLiveCheck();
      } else {
        alert(`Tarayıcınız MPEG-TS canlı yayını desteklemiyor.`);
      }
    },
    startResizeObserver() {
      const videoAreaElement = this.$refs.videoAreaRef;

      if (videoAreaElement) {
        this.observer = new ResizeObserver(entries => {
          for (const entry of entries) {
            const newWidth = entry.contentRect.width;
            window.requestAnimationFrame(() => {
              this.videoWidth = newWidth;
            });
          }
        });
        this.observer.observe(videoAreaElement);
      }
    }
  },
  mounted() {
    this.startPlayer();
    this.startResizeObserver();
  },
  beforeUnmount() {
    if (this.player) {
      this.player.destroy();
    }
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  min-height: 250px;
  max-width: 400px !important;
  border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.video {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg) scale(1.78);
  transform-origin: center center;
  object-fit: contain;
}

.live-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

.live-indicator.live {
  background-color: #00ff00;
}

.live-indicator.stale {
  background-color: #ff0000;
}
</style>